<ng-content select="[projection-location='sliders']"></ng-content>

<strong>Options</strong>

<ng-content select="[projection-location='options']"></ng-content>
<h3-checkbox
  [nasModel]="persistLayerSettingsStore"
  (change)="trackPersistenceChange()"
>
  Save settings across tasks
</h3-checkbox>
